'use client';
import React from 'react';
import { ProductBreadcrumbs as SharedProductBreadcrumbs } from '@launchstore/shared-puck';
import type { ProductBreadcrumbsProps } from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import type { ProductData } from '@launchstore/shared-puck';

const toProductData = (p: any): ProductData | null => {
  if (!p) return null;
  return {
    id: p.id, title: p.title, description: p.description, handle: p.handle,
    collection: p.collection ? { title: p.collection.title, handle: p.collection.handle } : null,
    categories: (p.categories || []).map((c: any) => ({ name: c.name, handle: c.handle })),
  };
};

const SharedProductBreadcrumbsRender = (SharedProductBreadcrumbs as any).render;

const ProductBreadcrumbsImpl: React.FC<ProductBreadcrumbsProps> = (props: any) => {
  const { product } = useProduct();
  return <SharedProductBreadcrumbsRender {...(props as any)} product={toProductData(product)} />;
};

export const ProductBreadcrumbs: any = { ...SharedProductBreadcrumbs, render: (props: any) => <ProductBreadcrumbsImpl {...props} /> };
export default ProductBreadcrumbs;
